import type { BeneficialOwnerData, BeneficialOwnerResponse } from '@gcv/shared';
import { injectable } from 'inversify';

import { api, banksApi } from './api-util/api';

@injectable()
export class BeneficialOwnerApi {
  async getBankBeneficialOwners(bankId: string, dispensaryId: string): Promise<BeneficialOwnerResponse[]> {
    return await banksApi().get(`/banks/${bankId}/dispensaries/${dispensaryId}/beneficial-owners`);
  }

  async bankCreateBeneficialOwner(
    bankId: string,
    dispensaryId: string,
    beneficialOwner: BeneficialOwnerData
  ): Promise<BeneficialOwnerResponse> {
    return await banksApi().post(`/banks/${bankId}/dispensaries/${dispensaryId}/beneficial-owners`, {
      beneficial_owner: beneficialOwner
    });
  }

  async bankUpdateBeneficialOwner(
    bankId: string,
    dispensaryId: string,
    beneficialOwnerId: string,
    beneficialOwner: BeneficialOwnerData
  ): Promise<BeneficialOwnerResponse> {
    return await banksApi().put(
      `/banks/${bankId}/dispensaries/${dispensaryId}/beneficial-owners/${beneficialOwnerId}`,
      {
        beneficial_owner: beneficialOwner
      }
    );
  }

  async bankUpdateBeneficialOwnerArchiveStatus(
    bankId: string,
    dispensaryId: string,
    beneficialOwnerId: string,
    archived: boolean
  ): Promise<BeneficialOwnerResponse> {
    return await banksApi().put(
      `/banks/${bankId}/dispensaries/${dispensaryId}/beneficial-owners/${beneficialOwnerId}/archive`,
      { archived }
    );
  }

  async getCrbBeneficialOwners(dispensaryId: string): Promise<BeneficialOwnerResponse[]> {
    return await api().get(`/dispensaries/${dispensaryId}/beneficial-owners`);
  }

  async crbCreateBeneficialOwner(
    dispensaryId: string,
    beneficialOwner: BeneficialOwnerData
  ): Promise<BeneficialOwnerResponse> {
    return await api().post(`/dispensaries/${dispensaryId}/beneficial-owners`, {
      beneficial_owner: beneficialOwner
    });
  }

  async crbUpdateBeneficialOwner(
    dispensaryId: string,
    beneficialOwnerId: string,
    beneficialOwner: BeneficialOwnerData
  ): Promise<BeneficialOwnerResponse> {
    return await api().put(`/dispensaries/${dispensaryId}/beneficial-owners/${beneficialOwnerId}`, {
      beneficial_owner: beneficialOwner
    });
  }

  async crbUpdateBeneficialOwnerArchiveStatus(
    dispensaryId: string,
    beneficialOwnerId: string,
    archived: boolean
  ): Promise<BeneficialOwnerResponse> {
    return await api().put(`/dispensaries/${dispensaryId}/beneficial-owners/${beneficialOwnerId}/archive`, {
      archived
    });
  }

  async crbConfirmBeneficialOwner(
    dispensaryId: string,
    beneficialOwnerId: string,
    templateResultId: string,
    confirmedOwner: boolean
  ): Promise<BeneficialOwnerResponse> {
    return await api().put(
      `/dispensaries/${dispensaryId}/beneficial-owners/${beneficialOwnerId}/confirm/${templateResultId}`,
      { confirmed_owner: confirmedOwner }
    );
  }
}
